import "./index.scss";
import Navigation from "./Components/Navigation";
import Banner from "./Components/Banner";
import Content from "./Components/Content";

const HomeScreen = () => {
  return (
    <div id={"home-page-screen"}>
      <Navigation />
      <Banner />
      <Content />
    </div>
  );
};

export default HomeScreen;
